<template>
  <div class="eqValEdit">
    <el-card class="card">
      <div slot="header"
           class="clearfix">
        <span>{{$t('menu.jbsz')}}</span>
      </div>
      <el-form :model="data"
               status-icon
               label-width="85px"
               class="demo-ruleForm"
               ref="ruleForm"
               :rules="rules">

        <el-form-item :label="$t('menu.sxz')"
                      prop="upVal">
          <el-input v-model.number="data.upVal" size="mini"
                    :placeholder="$t('menu.sxz')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('menu.xxz')"
                      prop="downVal">
          <el-input v-model.number="data.downVal" size="mini"
                    :placeholder="$t('menu.sxz')"></el-input>
        </el-form-item>
      </el-form>
      <div class="btnmg">
        <el-button type="primary" size="mini"
                    @click="save()">{{$t('menu.queding')}}</el-button>
        <el-button size="mini" @click="cancle">{{$t('menu.cancel')}}</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import ApiService from '@/services/API-services'
export default {
  name: 'eqValEdit',
  props: ['modalInfo'],
  data() {
    return {

      data: {
        upVal: '',
        downVal: ''
      },

      rules: {

        upVal: [{
          type: 'number',
          required: true,
          message: '请输入数值',
          trigger: 'blur'
        }
        ],
        downVal: [{
          type: 'number',
          required: true,
          message: '请输入数值',
          trigger: 'blur'
        }]
      },
      showResult: false
    }
  },

  mounted() {
    // this.setData(this.formdata);
    this.setData(this.modalInfo)
  },
  watch: {
    modalInfo: function(val) {
      this.setData(val)
    }
  },
  methods: {
    setData(val) {
      if (val) {
        this.data.upVal = parseFloat(val.OnlineValue) | ''
        this.data.downVal = parseFloat(val.OfflineValues) | ''
      }
    },
    cancle() {
      this.$store.commit('closeModal', 'eqValEdit')
    },
    save() {
      console.log(this.modalInfo)
      let isChecked = true
      this.$refs['ruleForm'].validate(valid => {
        isChecked = valid
      })
      if (!isChecked) {
        return
      }
      var msg = '设置成功'

      ApiService.tree.addwarningsetting({
        ID: this.modalInfo.id,
        OnlineValue: this.data.upVal+'',
        OfflineValues: this.data.downVal+''
      })
        .then(res => {
          if (res.code == 0) {
            console.log(res.data)
            this.$refs['ruleForm'].resetFields()
            this.$message({
              message: msg,
              type: 'success'
            })
            this.$store.commit('closeModal', 'eqValEdit')
          } else {
            this.$message.error(res.msg)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../common/css/color.scss';
.eqValEdit {
  .card {
    width: 342px;
    box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.2), 0px 6px 16px 0px rgba(0, 0, 0, 0.32), 0px 3px 6px -4px rgba(0, 0, 0, 0.48) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/equipment/eqValEdit.vue